import './ytTabsCard.scss'

export default {
    name: 'YtTabsCard',

    components: {

    },

    props: {
        value: {
            type: [Number, String],
            default: ''
        },

        // 选项卡是否高亮图标
        fillIcon: {
            type: Boolean,
            default: false
        },

        // 选项卡数据：{ label: String, value: Number, icon: String, number: Number, position: String: 'prefix' | 'suffix', tooltip: String }
        // 如果指定了提示文字则自动添加提示图标
        // 如果同时指定了图标和提示文字，则使用传入的图标
        // `number` 用于选项卡名称后添加 '选项卡名（number)' 数据
        options: {
            type: Array,
            default() {
                return []
            }
        },

        // 选项卡大小，'small' | 'normal'， 分别对应 `40px` 和 `60px` 高度
        size: {
            type: String,
            default: 'normal'
        },

        shadow: {
            type: String,
            default: 'always'
        }
    },

    data() {
        return {
            localValue: this.value
        }
    },

    watch: {
        value(val) {
            this.localValue = val
        },

        localValue(val) {
            this.$emit('input', val)
        }
    },

    methods: {
        handleTabToggle(index, tab) {
            this.localValue = tab.value
        }
    },

    render() {
        return (
            <el-card class='ytTabsCard' shadow={this.shadow}>
                <div class='tabs'>
                    <div class={`tabs_header ${this.size}`}>
                        <div class='tabs-header_nav'>
                            {
                                this.options.map((tab, index) => {
                                    return (
                                        <div
                                            class={`tabs_nav ${this.localValue === tab.value ? 'active' : ''} ${this.fillIcon ? 'highlight' : ''} ${this.size}`}
                                            onClick={() => this.handleTabToggle(index, tab)}
                                        >
                                            {
                                                // 左边图标
                                                (tab.position === 'prefix' && tab.icon && !tab.tooltip) && (
                                                    <div class='prefix'>
                                                        <i class={`iconfont ${tab.icon}`} />
                                                    </div>
                                                )

                                            }
                                            {
                                                // 左边图标 + 提示
                                                (tab.position === 'prefix' && tab.icon && tab.tooltip) && (
                                                    <div class='prefix'>
                                                        <yt-tooltip content={tab.tooltip}>
                                                            <i class={`iconfont ${tab.icon}`} slot='elem' />
                                                        </yt-tooltip>
                                                    </div>
                                                )
                                            }
                                            {
                                                // 左边默认图标 + 提示
                                                (tab.position === 'prefix' && !tab.icon && tab.tooltip) && (
                                                    <div class='prefix'>
                                                        <yt-tooltip content={tab.tooltip}>
                                                            <i class='iconfont iconquestion' slot='elem' />
                                                        </yt-tooltip>
                                                    </div>
                                                )
                                            }

                                            <div class='tabs-title'>
                                                {
                                                    tab.label
                                                }
                                                {
                                                    tab.number >= 0 && <span>（{tab.number}）</span>
                                                }
                                            </div>

                                            {
                                                // 右边图标
                                                (tab.position === 'suffix' && tab.icon && !tab.tooltip) && (
                                                    <div class='suffix'>
                                                        <i class={`iconfont ${tab.icon}`} />
                                                    </div>
                                                )

                                            }
                                            {
                                                // 右边图标 + 提示
                                                (tab.position === 'suffix' && tab.icon && tab.tooltip) && (
                                                    <div class='suffix'>
                                                        <yt-tooltip content={tab.tooltip}>
                                                            <i class={`iconfont ${tab.icon}`} slot='elem' />
                                                        </yt-tooltip>
                                                    </div>
                                                )
                                            }
                                            {
                                                // 右边默认图标 + 提示
                                                (tab.position === 'suffix' && !tab.icon && tab.tooltip) && (
                                                    <div class='suffix'>
                                                        <yt-tooltip content={tab.tooltip}>
                                                            <i class='iconfont iconquestion' slot='elem' />
                                                        </yt-tooltip>
                                                    </div>
                                                )
                                            }
                                        </div>
                                    )
                                })
                            }
                        </div>
                        {
                            this.$slots.extra && <div class='tabs-header_extra'>{this.$slots.extra}</div>
                        }
                    </div>
                    <div class='tabs_content'>
                        {
                            // 选项卡切换时不变的内容 - 前
                            this.$slots.pre && <div class='content--pre'>{this.$slots.pre}</div>
                        }

                        <div class='content'>{this.$slots.default}</div>

                        {
                            // 选项卡切换时不变的内容 - 后
                            this.$slots.post && <div class='content--post'>{this.$slots.post}</div>
                        }
                    </div>
                </div>
            </el-card>
        )
    }
}
